<template>
  <div class="ts-steps">
    <div class="dots">
      <div v-for="(step, i) in steps" :key="i" class="wrapper">
        <div v-if="i" class="separator"></div>
        <div class="dot" :class="{ selected: current >= i }">
          <ts-icon v-if="current > i" icon="check" size="xx-small" color="white"></ts-icon>
        </div>
      </div>
    </div>
    <div v-if="currentName" class="name">{{ currentName }}</div>
  </div>
</template>

<style lang="scss" scoped>
.ts-steps {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.dots {
  display: flex;

  .wrapper {
    display: flex;
    align-items: center;
  }

  .dot {
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 16px;
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.8) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.32);
    box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

    &.selected {
      box-shadow: 5px 5px 10px 0 rgba(166, 171, 189, 0.48), -5px -5px 10px 0 rgba(250, 251, 255, 0.8);
      border: solid 2px rgba(255, 255, 255, 0.16);
      background-blend-mode: soft-light, normal;
      background-image: linear-gradient(318deg, #000000, #ffffff -5%), linear-gradient(to bottom, #99ffd1, #99ffd1);
    }
  }

  .separator {
    width: 21px;
    height: 5px;
    margin: 0 4px;

    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 1px solid rgba(255, 255, 255, 0.32);
    box-shadow: inset 2px 2px 4px 0 #cacaca, inset -2px -2px 4px 0 #fafbff;
    border-radius: 5px;
  }
}

.name {
  font-family: Roboto;
  font-size: 10px;
  text-align: center;
  color: #9aa5b7;

  margin-top: 12px;
}
</style>

<script>
export default {
  name: 'TsSteps',
  props: {
    current: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentName() {
      return this.steps[this.current]?.name;
    }
  }
};
</script>
